module.exports = __webpack_public_path__ + "img/img3.70e229b3.png";